import React from 'react';
import { CircleCheck as CheckCircle, Users, Shield } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const TrustProofSection = () => {
  const { t } = useLanguage();
  const videoId = 'BgR6oWA7ghY';
  
  return (
    <section className="py-20 md:py-28 bg-[#F9F6F4]" data-testid="trust-proof-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="space-y-6">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 leading-tight" style={{ fontFamily: 'Manrope, sans-serif' }}>
              {t('trustProof.title')}{' '}
              <span className="text-[#009d9f]">{t('trustProof.titleHighlight')}</span>{' '}
              {t('trustProof.titleEnd')}
            </h2>
            <p className="text-lg md:text-xl text-slate-600 leading-relaxed">{t('trustProof.description')}</p>
            <div className="space-y-4 pt-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-[#009d9f]/10 flex items-center justify-center">
                  <CheckCircle className="w-5 h-5 text-[#009d9f]" />
                </div>
                <span className="text-slate-700 font-medium">{t('trustProof.point1')}</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-[#009d9f]/10 flex items-center justify-center">
                  <Users className="w-5 h-5 text-[#009d9f]" />
                </div>
                <span className="text-slate-700 font-medium">{t('trustProof.point2')}</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-[#009d9f]/10 flex items-center justify-center">
                  <Shield className="w-5 h-5 text-[#009d9f]" />
                </div>
                <span className="text-slate-700 font-medium">{t('trustProof.point3')}</span>
              </div>
            </div>
          </div>

          <div className="relative" data-testid="video-container">
            <div className="aspect-video rounded-3xl overflow-hidden shadow-2xl border-4 border-white">
              <iframe
                src={`https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1`}
                title="Bianhi Medical Hair Restoration"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="w-full h-full"
              />
            </div>
            <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-[#009d9f]/20 rounded-full blur-2xl" />
            <div className="absolute -top-4 -left-4 w-32 h-32 bg-[#009d9f]/10 rounded-full blur-3xl" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustProofSection;
